import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import CartaServicoService from '../../../services/cartaServico';
import { Link } from 'react-router-dom';
import '../../../styles/diario.scss';
import Exportar from '../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [servico, setServico] = useState("");
    const [local, setLocal] = useState("");
    const [palavra, setPalavra] = useState("");
    const [secretaria, setSecretaria] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchCartas()
            setServico("")
        } else {
            var response = await CartaServicoService.buscar(query)
            if (response.data.length >= 1) {
                props.setCartas(response.data)
                props.setVazio(false)
                setServico("")

            } else {
                props.setVazio(true)
                setServico("")

            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (servico) prepQuery = prepQuery + `&servico=${encodeURI(servico)}`;
        if (local) prepQuery = prepQuery + `&local=${encodeURI(local)}`;
        if (palavra) prepQuery = prepQuery + `&palavra=${encodeURI(palavra)}`;
        if (secretaria !== "false" && secretaria != "false" && secretaria !== "") prepQuery = prepQuery + `&secretaria=${encodeURI(secretaria)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="servico">
                                <FloatingLabel
                                    label="Serviço"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="servico"
                                        value={servico}
                                        onChange={e => setServico(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="servico">
                                <FloatingLabel
                                    label="Bairro"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="local"
                                        value={local}
                                        onChange={e => setLocal(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="palavra">
                                <FloatingLabel
                                    label="Palavra-chave"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="palavra"
                                        value={palavra}
                                        onChange={e => setPalavra(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Secretaria">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {props.secretarias.map((sec) =>
                                            <option value={sec.nome}>{sec.nome}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/orgaos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.cartas} nome={"Cartas"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#429a8717-58fd-4900-b95f-bb2e7c466822" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
